// extracted by mini-css-extract-plugin
module.exports = {"deadline":"c6e8ba5398--deadline--3mUGe"};